// Imports
import ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ from "../../../../node_modules/html-loader/dist/runtime/getUrl.js";
var ___HTML_LOADER_IMPORT_0___ = new URL("./loading.gif", import.meta.url);
var ___HTML_LOADER_IMPORT_1___ = new URL("./close.png", import.meta.url);
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var ___HTML_LOADER_REPLACEMENT_1___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_1___);
var code = "<div class=\"qp-loading\"> <div class=\"qp-loading__mask\"></div> <img class=\"qp-loading__img\" src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\"/> <img class=\"qp-loading__close\" src=\"" + ___HTML_LOADER_REPLACEMENT_1___ + "\" ng-show=\"$qp_loading_close_enabled\" ng-click=\"$qp_loading_click()\"/> </div>";
// Exports
export default code;